module.exports = __webpack_public_path__ + "static/Sushi-ii-5e2e799f5af72d886375ca240ace595d.gif";